declare global {
  interface Window {
    vmtChartData?: unknown[];
    vmtChartLocationKey?: string;
  }
}

/**
 * In-memory VMT cache shared by Transportation, Overview, and GHG inventory.
 * Kept in a leaf module (no DataService imports) so LocationContext can clear it
 * without circular-import issues with vmtDataService.
 */

export interface VMTDataPoint {
  year: number;
  vmt: number;
  source?: string;
  method_note?: string;
}

let globalVMTData: VMTDataPoint[] = [];
let globalVMTDataLocationKey: string | null = null;

export type InFlightVMT = { key: string; promise: Promise<VMTDataPoint[]> } | null;
let inFlightVMT: InFlightVMT = null;

export function getGlobalVMTData(): VMTDataPoint[] {
  return globalVMTData;
}

export function setGlobalVMTData(data: VMTDataPoint[], locationKey: string | null): void {
  globalVMTData = data;
  globalVMTDataLocationKey = locationKey;
}

export function getGlobalVMTDataLocationKey(): string | null {
  return globalVMTDataLocationKey;
}

export function getInFlightVMT(): InFlightVMT {
  return inFlightVMT;
}

export function setInFlightVMT(entry: InFlightVMT): void {
  inFlightVMT = entry;
}

/** Clear cached VMT when the user changes location. */
export function clearVMTData(): void {
  globalVMTData = [];
  globalVMTDataLocationKey = null;
  inFlightVMT = null;
  if (typeof window !== 'undefined') {
    delete window.vmtChartData;
    delete window.vmtChartLocationKey;
  }
}
